import { render, staticRenderFns } from "./addEca.vue?vue&type=template&id=c2c66608&scoped=true"
import script from "./addEca.vue?vue&type=script&lang=js"
export * from "./addEca.vue?vue&type=script&lang=js"
import style0 from "./addEca.vue?vue&type=style&index=0&id=c2c66608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c66608",
  null
  
)

export default component.exports